module.exports = __webpack_public_path__ + "img/excited.be5030ca.webp";